import React, { useState } from "react";

import { BaseModal } from "../../../atoms/base-modal";
import {
  PrimaryButton,
  SecondaryButton,
} from "@graffer-inc/console-design-kit";
import {
  MaxNameLength,
  MaxPriority,
} from "../../../../application/service/proc-management/procedure-tag-list-base";

type Props = {
  isActive: boolean;
  onClose: () => void;
  onCreate: (
    name: string,
    priority: number,
    suppressOnPortal: boolean,
    pageNum: number,
  ) => void;
  pageNum: number;
};

export const ProcTagCreateModal: React.FC<Props> = ({
  isActive,
  onClose,
  onCreate,
  pageNum,
}) => {
  const [name, setName] = useState("");
  const [priority, setPriority] = useState(1);
  const [suppressOnPortal, setSuppressOnPortal] = useState<boolean>(false);

  return (
    <BaseModal title="手続きタグ作成" isActive={isActive} onClose={onClose}>
      <section className="modal-card-body">
        <div className="field">
          <div className="label">名称</div>
          <div className="control">
            <input
              className="input"
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
          </div>
        </div>
        <div className="field">
          名称は{MaxNameLength}文字以内にしてください。
        </div>
      </section>
      <section className="modal-card-body">
        <div className="field">
          <div className="label">表示順</div>
          <div className="control">
            <input
              className="input"
              type="number"
              value={String(priority)}
              onChange={(e) => setPriority(parseInt(e.target.value, 10))}
            />
          </div>
        </div>
        <div className="field">
          表示順は1以上{MaxPriority}未満の整数を指定してください。
        </div>
      </section>
      <section className="modal-card-body">
        <div className="field">
          <label className="label">トップページへの掲載可否</label>
          <div className="control">
            <div className="select">
              <select
                value={suppressOnPortal ? 1 : 0}
                onChange={(e) => setSuppressOnPortal(e.target.value === "1")}
              >
                <option value={0}>掲載する</option>
                <option value={1}>掲載しない</option>
              </select>
            </div>
          </div>
        </div>
      </section>

      <footer className="modal-card-foot">
        <SecondaryButton text={"キャンセル"} onClick={onClose} />
        <PrimaryButton
          text={"登録する"}
          onClick={() => onCreate(name, priority, suppressOnPortal, pageNum)}
          disabled={
            name.length < 1 ||
            name.length > MaxNameLength ||
            priority < 1 ||
            priority > MaxPriority
          }
        />
      </footer>
    </BaseModal>
  );
};

export default ProcTagCreateModal;
